export default __webpack_public_path__ + "media/music/b917632136b189767bfb9e3e6c87166f.mp3";